import {Fragment, useEffect, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {SendEmailService} from '../../../service/invoice/SendEmailService';

import {useDataTable} from '../../../shared/hooks/DataTable';

export const DialogSentEmail = (props) => {

  const {selectedItem} = props;

  const [display, setDisplay] = useState(false);
  const [requiredParams, setRequiredParams] = useState(null);
  const typeSendEmail = [
    {value: "0", label: ''},
    {value: "1", label: 'Gửi hóa đơn'},
    {value: "2", label: 'Gửi xác nhậ'},
    {value: "3", label: 'Gửi tải khoản'},
    {value: "4", label: 'Thông báo sai sót'}
  ];
  useEffect(() => {
    if (selectedItem) {
      setRequiredParams({invoiceId: selectedItem.id});
    }
  }, [selectedItem]);
 
  const {render: renderDataTable} = useDataTable({
    columns: [
      {field: 'invoiceSerial', header: 'Ký hiệu', width: 90},
      {field: 'invoiceNo', header: 'Số hóa đơn', width: 100},
      {field: 'invoiceDate', header: 'Ngày hoá đơn', width: 110, dataType: 'date'},
      {field: 'emailTo', header: 'Email khách hàng', minWidth: 160},
      {field: 'dateSendEmail', header: 'Ngày gửi', width: 140, dataType: 'date-time'},
      {field: 'statusName', header: 'Trạng thái gửi', width: 120},
      {
        field: 'isWatched', header: 'Xem', width: 60, dataType: 'custom', customCell(rowData: any): any {
          if (rowData.isWatched) {
            return <span className={`ss04-status invoice-status-0 pi pi-eye mr-3`} title='Đã xem'></span>;
          }
          return <span className={`ss04-status invoice-status-1 pi pi-eye-slash mr-3`} title='Chưa xem'></span>;
        }
      },
      {field: 'sendTypeName', header: 'Loại nghiệp vụ', width: 140, dataType: 'custom', customCell(rowData: any): any {
        return  typeSendEmail[rowData.type]?.label;
        }
      }
    ],
    indexColumnWidth: 40,
    getList: (params) => {
       return appendData(params)
    },
    rows: 20,
    requiredParams
  });
  const appendData =async (params)  => {
    const data =  await SendEmailService.getList(params)
    const modifiedData = data.items.map(item=>({
      ...item,
      invoiceNo:selectedItem.invoiceNumber,
      invoiceDate:selectedItem.invoiceDate
    }))
    return {
      ...data,
      items:modifiedData
    }
  }

  return (
    <Fragment>
      <div className="field grid">
        <div className="col-12 md:col-12">
          <b className="p-link" onClick={() => setDisplay(true)}>Kiểm tra lịch sử gửi email</b>
        </div>
      </div>
      <Dialog header="Lịch sử gửi email" visible={display} style={{width: '80rem'}} position="top" onHide={() => setDisplay(false)}>
        {renderDataTable()}
        <div className="flex justify-content-end">
          <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-text p-button-sm"/>
        </div>
      </Dialog>
    </Fragment>
  );
}